// Errors thrown by `callJson` arrive as `new Error('Status code: NNN; {json}')`
// — the backend JSON body is stringified into the message. These helpers pull
// out the backend `detail` field so callers can show the user-facing message
// (e.g. the eval-run deprecation 400) instead of the envelope.

export type ParsedRunCreateError = {
  status?: number;
  detail: string;
};

const ENVELOPE = /^Status code:\s*(\d+);\s*(.+)$/s;

export function parseRunCreateError( err: unknown ): ParsedRunCreateError {
  const raw = err instanceof Error ? err.message : typeof err === 'string' ? err : '';
  const match = raw.match( ENVELOPE );
  if( !match ) return { detail: raw };

  const status = parseInt( match[1], 10 );
  const tail = match[2];
  try {
    const body = JSON.parse( tail );
    if( body && typeof body.detail === 'string' ) {
      return { status, detail: body.detail };
    }
  } catch {
    // tail wasn't JSON; fall through to using it as-is
  }
  return { status, detail: tail };
}

export function formatRunCreateError( detail: string ): string {
  if( /deprecated/i.test( detail ) ) {
    return `Cannot create run — ${ detail } Un-deprecate it first to run.`;
  }
  return detail;
}
